import { Component, OnInit, EventEmitter, Output, Input, ViewChild, ChangeDetectorRef } from '@angular/core';
import { EstadoCuentaInformacionInput, CalculoCargosAguasInput, AuxJasper, ParametroJasper, RegistroBitacoraInput, CargosDetallesInput, ConsultaLecturasInput, BitacoraEstadoCuentaMasivoInput, BitacoraEstadoCuentaMasivo, ConsultaLecturas } from "../../entidades/entidades";
import { JasperService } from "../../servicios/jasper.service";
import { MuestraMensaje } from '../../shared/utilerias/notificaciones/notificaciones.component';
import { RegistroBitacoraService } from '../../servicios/registro-bitacora.service';
import { CalculoCargosAguasService} from '../../servicios/calculo-cargos-aguas.service';
import { AuthenticationService } from '../../servicios/authentication.service';
import { now } from 'jquery';
import { Config } from "../../entidades/entidades";
import { EstadoCuentaInformacionService } from 'app/servicios/estado-cuenta-informacion.service';
import { BitacoraEstadoCuentaMasivoService } from 'app/servicios/bitacora-estado-cuenta-masivo.service';
import { VencimientosLecturaComponent } from '../vencimientos-lectura/vencimientos-lectura.component';
import { ConsultaLecturasComponent } from '../consulta-lecturas/consulta-lecturas.component';
import { execDbService } from 'app/servicios/exec-db.service';

@Component({
  selector: 'app-estadocuentamasivo',
  templateUrl: './estadocuentamasivo.component.html',
  styleUrls: ['./estadocuentamasivo.component.css']
})
export class EstadocuentamasivoComponent implements OnInit {
  message: string;
  public auxJasper: AuxJasper = new AuxJasper();
  public combos: ConsultaLecturasInput;
  muestraMensaje = new MuestraMensaje();
  public registroBitacora = new RegistroBitacoraInput();
  public registroBitacoraEstadoCuentaMasivo = new BitacoraEstadoCuentaMasivo();
  public calculoCargosAguasInput: CalculoCargosAguasInput;
  public estadoCuentaInformacionInput: EstadoCuentaInformacionInput;
  public estatus: any;
  progressBar = false;
  idUsuario: any;
  idAmbiente: number;
  @ViewChild(ConsultaLecturasComponent, { static: false }) childConsultaLecturas;
  public segmentos: number = 0; 
  public ragoSegmento: number = 200;
  public ragoSegmentoCalcular: number = 200;
  public offset: number = 0;
  public progressBarImprimir: boolean = false;
  public progressBarProcesar: boolean = false;
  public contadorSegmento: number = 0;
  public totalRecord: number = 0;
  public archivoGeneradoSubject = new EventEmitter<void>();
  public progressBarCalculo: boolean = false;

  constructor(private jasperService: JasperService, 
    private registroBitacoraService: RegistroBitacoraService,
    private authenticationService: AuthenticationService,
    private calculoCargosAguasService: CalculoCargosAguasService,
    private estadoCuentaInformacionService: EstadoCuentaInformacionService,
    private registroBitacoraEstadoCuentaMasivoService: BitacoraEstadoCuentaMasivoService,
    private changeDetector: ChangeDetectorRef,
    private execDbService: execDbService,
  ) { }

  display: boolean = false;
  showDialog() {
    this.display = false;
  }

  ngOnInit(): void {
    let config: Config = JSON.parse(localStorage.getItem("config"));
    this.idAmbiente = config.IdAmbiente;

    this.idUsuario = this.authenticationService.currentUserValue.id;

  }


  async imprimirRecepcion(estadoCuentaInformacionInput: ConsultaLecturasInput){
    try {
        this.progressBar = true;
        this.combos = new ConsultaLecturasInput();
        this.combos = estadoCuentaInformacionInput;

        this.auxJasper = new AuxJasper();
        this.auxJasper.JasperReport.nombreReporte = "RecepcionRecibos";
        this.auxJasper.JasperReport.tipo = "pdf";
        this.auxJasper.JasperReport.imprimir = true;

        let _des_ruta = new ParametroJasper();
        _des_ruta.nombre = "_ruta"
        _des_ruta.valor = this.combos.rutaDesc + "";

        let _ruta = new ParametroJasper();
        _ruta.nombre = "_id_ruta";
        _ruta.valor = this.combos.ruta?.toString() + "";

        let _periodo_parcialidad = new ParametroJasper();
        _periodo_parcialidad.nombre = "_periodo_parcialidad";
        _periodo_parcialidad.valor = this.combos.periodo + "";

        let _anio = new ParametroJasper();
        _anio.nombre = "_anio";
        _anio.valor = this.combos.anioIn + "";

        await this.auxJasper.ParametroJasper.push(_des_ruta);
        await this.auxJasper.ParametroJasper.push(_ruta);
        await this.auxJasper.ParametroJasper.push(_periodo_parcialidad);
        await this.auxJasper.ParametroJasper.push(_anio);
        
        this.showDialog();
        this.registroBitacora.idUsuario = this.idUsuario;
        this.registroBitacora.accion = "SE GENERA REPORTE RECEPCIÓN DE RECIBOS";
        const datoRetorno = await this.registroBitacoraService.add(this.registroBitacora).toPromise();

    } catch (e) {
      this.muestraMensaje.error(e , "top", "center");
      this.progressBar = false;
    }
    finally{
      console.log("Paso por imprimir Recepción")
    };
  };

  async imprimeResibos(consultaLecturasInput: ConsultaLecturasInput){
    try {

        if(!consultaLecturasInput._reimpresion_recibo){
          await this.childConsultaLecturas.guardarGridLecturasObservacion();
        }
        
        
        let estadoCuentaInformacionInput = new EstadoCuentaInformacionInput();
        estadoCuentaInformacionInput.idRuta = consultaLecturasInput.ruta;
        estadoCuentaInformacionInput.periodoParcialidad = consultaLecturasInput.periodo;
        estadoCuentaInformacionInput.anio = consultaLecturasInput.anioIn;

        this.progressBarProcesar = true;

        const cunetasInformacion = await this.estadoCuentaInformacionService.registrosEstadoCuentaRecibos(estadoCuentaInformacionInput).toPromise();

        this.progressBarProcesar = false; 

        if(cunetasInformacion[0]["recordsTotal"] == 0 ){
          this.muestraMensaje.error("No se encontraron registros para generar los recibos" , "top", "center");
          return;
        }

        this.totalRecord = cunetasInformacion[0]["recordsTotal"];  
        this.segmentos =  Math.ceil(this.totalRecord / this.ragoSegmento);

        //iteramos por cada segmento obteniendo el valor de offset
        for (let cont = 1; cont <= this.segmentos; cont++) {
            this.offset =  (cont - 1) * this.ragoSegmento;
            this.contadorSegmento = cont;
        
            this.changeDetector.detectChanges(); // Actualizar la UI antes de la llamada
             
            console.log(`Imprimiendo segmento ${cont} de ${this.segmentos}`);

            await new Promise(resolve => setTimeout(resolve, 1000)); // Pequeña pausa para actualizar UI
            await this.llamadaJaspertReport(consultaLecturasInput);
            
          }

          if(!consultaLecturasInput._reimpresion_recibo){
              // se manda a llamas servicio de execDb (funcion generica)
              const inputJson = { "id_operacion": 2, "id_agua_zona": estadoCuentaInformacionInput.idRuta};
              this.progressBar = true;
              const datoRet = await this.execDbService.processJsonData(inputJson).toPromise();
              this.progressBar = false;
          }
        

          let msjBitacora =  consultaLecturasInput._reimpresion_recibo ? "SE GENERA IMPRESION RECIBOS MASIVOS REIMPRESION" : "SE GENERA IMPRESION RECIBOS MASIVOS";
         
           // se registra en la bitacora el proceso de impresion de recibos
          this.registroBitacora.idUsuario = this.idUsuario;
          this.registroBitacora.accion = msjBitacora;
          const datoRetorno = await this.registroBitacoraService.add(this.registroBitacora).toPromise();
      
       
          
        
    } catch (error) {
      this.muestraMensaje.error(error , "top", "center");
    }
    finally {
      this.progressBar = false;
      this.progressBarProcesar = false;
      this.progressBarImprimir = false; 
    };
  };

  async childEstadoCuentaMasivo(estadoCuentaInformacionInput: ConsultaLecturasInput) {
    this.calculoCargosAguasInput = new CalculoCargosAguasInput();
    this.combos = estadoCuentaInformacionInput;

    //let datos = this.childConsultaLecturas.consultaLectura;
    //this.totalRecord = datos.length;
    this.segmentos = Math.ceil(this.totalRecord / this.ragoSegmentoCalcular);

    try {
     
      for (let cont = 1; cont <= this.segmentos; cont++) {
        this.offset =  (cont - 1) * this.ragoSegmento;
        this.contadorSegmento = cont;

        this.calculoCargosAguasInput.idAgua = null
        this.calculoCargosAguasInput.cuentaAgua = this.combos.cuentaAgua;
        this.calculoCargosAguasInput.colonia = null//this.combos.colonia;
        this.calculoCargosAguasInput.actualizaCargos = true;
        this.calculoCargosAguasInput.fechaCalculos =  new Date();
        this.calculoCargosAguasInput.idEstatus = 1;
        this.calculoCargosAguasInput.conEstimadoAnual = false;
        this.calculoCargosAguasInput.idRuta = this.combos.ruta;
        this.calculoCargosAguasInput.fechaEmision = this.combos.fechafac;
        this.calculoCargosAguasInput.fechaFacturacion = this.combos.fechaemisi;
        this.calculoCargosAguasInput.fechaVencimiento = this.combos.fechavence;
        this.calculoCargosAguasInput.periodo = this.combos.periodo;
        this.calculoCargosAguasInput.anio = this.combos.anioIn;
        this.calculoCargosAguasInput.limit = this.ragoSegmentoCalcular;
        this.calculoCargosAguasInput.offset = this.offset;
        this.calculoCargosAguasInput.aplicaSf = false;

        this.progressBarCalculo = true;

        const datoretornoCalculo = await this.calculoCargosAguasService.calculoAguasBySegmento(this.calculoCargosAguasInput).toPromise();
        
        if(datoretornoCalculo){
          //esperamos un segundo para que se actualice la barra de progreso
          await new Promise(resolve => setTimeout(resolve, 1000)); // Pequeña pausa para mostrar los mensajes
          this.muestraMensaje.notification("Calculo realizado correctamente, puede generar los recibos" , "top", "center");
          this.muestraMensaje.notification(datoretornoCalculo.message , "top", "center");
          //this.progressBar = false;
        };

      }

      this.registroBitacora.idUsuario = this.idUsuario;
      this.registroBitacora.accion = "SE GENERA CALCULO RECIBOS MASIVOS RUTA: " + this.combos.rutaDesc + " - " + this.combos.periodo 
      
      const datoRetorno = await this.registroBitacoraService.add(this.registroBitacora).toPromise();

     
    } catch (e) {
      this.muestraMensaje.error(e , "top", "center");
      this.muestraMensaje.error("El calculo no se genero correctamente" , "top", "center");
      this.progressBar = false;
    } finally {
      console.log("Paso por calculo masivo")
      //this.progressBar = false;
      this.progressBarCalculo = false;
    }
  }

  setSeleccionado(estado) {
    this.estatus = estado;
    this.progressBar = false;
  }

  async llamadaJaspertReport(consultaLecturasInput: ConsultaLecturasInput): Promise<void>{

      this.combos = new ConsultaLecturasInput();
      this.combos = consultaLecturasInput;

      this.auxJasper = new AuxJasper();
      this.auxJasper.JasperReport.nombreReporte = "EstadoDeCuenta";
      this.auxJasper.JasperReport.tipo = "pdf";
      this.auxJasper.JasperReport.imprimir = true;
      // se usara este atributo para enviar el nombre del archivo al generar la descarga en el visor
      this.auxJasper.JasperReport.urlGeneral = "EstadoDeCuenta_" + this.contadorSegmento.toString() + "-" + this.segmentos.toString();

      let _cuenta_agua = new ParametroJasper();
      _cuenta_agua.nombre = "_cuenta_agua";
      _cuenta_agua.valor =  this.combos.cuentaAgua?.toString() + "";

      let _anio = new ParametroJasper();
      _anio.nombre = "_anio";
      _anio.valor = this.combos.anioIn.toString() + "";
  
      let _periodo_parcialidad = new ParametroJasper();
      _periodo_parcialidad.nombre = "_periodo_parcialidad";
      _periodo_parcialidad.valor = this.combos.periodo.toString() + "";
        
      let _ruta = new ParametroJasper();
      _ruta.nombre = "_id_ruta";
      _ruta.valor = this.combos.ruta?.toString() + "";

      let _avisoDirec = new ParametroJasper();
      _avisoDirec.nombre = "_aviso_directivo";
      _avisoDirec.valor = this.combos.avisoDirec.toString() + "";

      let _idAmbiente = new ParametroJasper();
      _idAmbiente.nombre = "_id_ambiente";
      _idAmbiente.valor = this.idAmbiente.toString() + "";

      let reimpresion = new ParametroJasper();
      reimpresion.nombre = "reimpresion";
      reimpresion.valor = "false";

      let _limit = new ParametroJasper();
      _limit.nombre = "_limit";
      _limit.valor = this.ragoSegmento.toString();

      let _offset = new ParametroJasper();
      _offset.nombre = "_offset";
      _offset.valor = this.offset.toString();

      let _reimprimir_recibo = new ParametroJasper();
      _reimprimir_recibo.nombre = "_reimpresion_recibo";
      _reimprimir_recibo.valor = this.combos._reimpresion_recibo.toString()

      await this,this.auxJasper.ParametroJasper.push(reimpresion);

      if(this.combos.cuentaAgua != null){
        await this.auxJasper.ParametroJasper.push(_cuenta_agua);
      }
    
      if(this.combos.ruta != null){
        await this.auxJasper.ParametroJasper.push(_ruta);
      }

      await this.auxJasper.ParametroJasper.push(_periodo_parcialidad);
      await this.auxJasper.ParametroJasper.push(_avisoDirec);
      await this.auxJasper.ParametroJasper.push(_idAmbiente);
      await this.auxJasper.ParametroJasper.push(_anio);
      await this.auxJasper.ParametroJasper.push(_limit);
      await this.auxJasper.ParametroJasper.push(_offset);
      await this.auxJasper.ParametroJasper.push(_reimprimir_recibo);

      this.changeDetector.detectChanges(); // Actualizar la UI antes de la llamada

      //Activar el progress bar cuando empieza la generación del archivo
      this.progressBarImprimir = true;
      this.changeDetector.detectChanges();

      return new Promise<void>((resolve) => {
        console.log("Esperando que el archivo se genere...");

        // Esperar hasta que el visor emita el evento de archivo generado
        const suscripcion = this.archivoGeneradoSubject.subscribe(() => {
            suscripcion.unsubscribe(); // Evitar múltiples suscripciones

            //Desactivar el progress bar solo cuando el archivo esté listo
            this.progressBarImprimir = false;
            this.changeDetector.detectChanges();

            resolve(); // Continuar con la siguiente iteración
        });

        this.showDialog();
      });
  };

  //  Emitimos el evento para que "llamadaJaspertReport()" continúe con la siguiente iteración
  onArchivoGenerado() {
    this.archivoGeneradoSubject.emit(); 
  }

  datosCargados(event){
    this.totalRecord = event
  }
}